import clsx from 'clsx'
import * as Hooks from '../../hooks'
import Description from '../Description'
import ErrorMessage from '../ErrorMessage'
import styles from './Controls.module.css'

export default function Layout({ name, description, label, children, ...props }) {
    const { parent, property } = Hooks.useSubSchema(name)
    const className = clsx(styles.Layout, props.className, {
        [styles.Required]: parent?.required?.some(value => value === property),
    })

    return (
        <div className={className}>
            {label && <label htmlFor={name}>{label}</label>}
            {children}
            <ErrorMessage name={name} />
            <Description>{description}</Description>
        </div>
    )
}
